<template>
    <div class="card">
      <KTCodePreview>
        <template v-slot:body>
            <b-tabs>
              <b-tab title="List Approval KRS" active>
                <ListApproval :dataEdit="props" />
              </b-tab>
              <b-tab title="KRS Approved">
                <KRSApproved :dataEdit="props" />
              </b-tab>
            </b-tabs>
        </template>
      </KTCodePreview>
    </div>
  </template>
  
  <script>
  import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
  import KTCodePreview from "@/view/content/CardContent.vue";
  import ListApproval from '@/view/pages/krs-admin/ListApproval.vue';
  import KRSApproved from "@/view/pages/krs-admin/KRSApproved.vue";
  
  export default {
    data() {
      return {
        props: this.$route.params.item ? JSON.parse(this.$route.params.item) : null,
      }
    },
    components: {
      KTCodePreview,
      ListApproval,
      KRSApproved,
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "KRS"},
        { title: "Approve KRS"},
      ]);
    }
  }
  </script>